import cx from 'classnames';
import React from 'react';
import styles from './thumbnail.module.scss';
import { ThumbnailBackground } from './thumbnail-background';
export var FontStyles;
(function (FontStyles) {
    FontStyles["BOLD"] = "bold";
    FontStyles["ITALIC"] = "italic";
    FontStyles["UNDERLINE"] = "underline";
    FontStyles["STRIKE_THROUGH"] = "strike-thorugh";
})(FontStyles || (FontStyles = {}));
export const Thumbnail = ({ id, className, backgroundColor = '#FFFFFF', displayText = 'Aa', textColor, fontStyles = [], }) => {
    const thumbnailWrapperClass = cx(styles.thumbnailWrapper, className);
    const textColorClass = { color: textColor };
    const fontStylesClass = cx({
        [styles.bold]: fontStyles.includes(FontStyles.BOLD),
        [styles.italic]: fontStyles.includes(FontStyles.ITALIC),
        [styles.underline]: fontStyles.includes(FontStyles.UNDERLINE),
        [styles.strikeThrough]: fontStyles.includes(FontStyles.STRIKE_THROUGH),
        [styles.underlineAndStrike]: fontStyles.includes(FontStyles.UNDERLINE) &&
            fontStyles.includes(FontStyles.STRIKE_THROUGH),
    });
    return (React.createElement("div", { id: id, className: thumbnailWrapperClass },
        React.createElement("div", { className: styles.displayTextWrapper },
            React.createElement("span", { style: textColorClass, className: fontStylesClass }, displayText)),
        ThumbnailBackground(backgroundColor)));
};
//# sourceMappingURL=thumbnail.js.map